import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Route } from 'react-router-dom'
import constants from 'utils/constants'
import TitleHeader from 'components/presenters/header/TitleHeader'
import CampaignNavBar from 'components/containers/campaign/CampaignNavBar'
import CampaignMainLayout from 'layouts/campaign/CampaignMainLayout'
import Community from 'components/containers/community/Community'
import CampaignAchievementLayout from 'layouts/campaign/CampaignAchievementLayout'
// import CampaignAchievementRate from 'components/containers/campaign/achievement/CampaignAchievementRate';
import Community_comment from 'components/campaign/community/community_detail/Community_comment'
import CommunityCommentLayout from 'layouts/community/CommunityCommentLayout'
import server from 'server/serverController2'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import BottomModal from 'components/presenters/modal/BottomModal'
import FeedGallery from 'components/containers/feed/FeedGallery'
import FeedLayout from 'layouts/feed/FeedLayout'
import CenterModal from 'components/presenters/modal/CenterModal'
import { isEmpty, formatDate } from 'utils/utils'

export default function Campaign({ match }) {
  const userInfo = useSelector((state) => {
    return state.userInfo
  })

  const history = useHistory()
  const [showModal, setShowModal] = useState(false)
  const [groupInfo, setGroupInfo] = useState({})
  const [isOwner, setIsOwner] = useState(false)
  const [isDotBtn, setIsDotBtn] = useState(false)
  const [isWaitingMember, setIsWaitingMember] = useState(false)
  //ModalState
  const [visible, setVisible] = useState(false)
  const [dataList, setDataList] = useState([])
  const [initBottomModal, setInitBottomModal] = useState(false)
  const [isCompany, setIsCompany] = useState(false)

  //Center Modal State
  const [initCenterModal, setInitCenterModal] = useState(false)
  const [centerModalVisible, setCenterModalVisible] = useState(false)
  const [centerModalDataList, setCenterModalDataList] = useState({})
  const [onModalComplete, setOnModalComplete] = useState(null)
  const [onModalCancel, setOnModalCancel] = useState(null)

  //Init Center Modal State
  useEffect(() => {
    if (initCenterModal === true) {
      setCenterModalVisible(false)
      setCenterModalDataList({})
      setOnModalComplete(null)
      setOnModalCancel(null)
      setInitCenterModal(false)
    }
  }, [initCenterModal])

  useEffect(() => {
    if (initBottomModal) {
      setVisible(false)
      setDataList([])
      setInitBottomModal(false)
    }
  }, [initBottomModal])

  const infoCallBack = (res) => {
    try {
      if (res.success !== 1) {
        if (res['error'] && res['error']['res_data']) {
          let errData = res['error']['res_data']
          if (errData['detail_code'] === 'CAMPAIGN_DOES_NOT_EXIST') {
            setCenterModalVisible(true)
            setCenterModalDataList({
              description: '해당 프로젝트가 존재하지 않습니다.',
              confirmTxt: '뒤로가기',
            })
            setOnModalComplete(() => () => {
              setInitCenterModal(true)
              history.push('/')
            })
          } else if (errData['detail_code'] === 'NOT_A_COMPANY_MEMBER') {
            setCenterModalVisible(true)
            setCenterModalDataList({ description: '해당 게시물을 열람할 권한이 없습니다.' })
            setOnModalComplete(() => () => {
              setInitCenterModal(true)
              history.push('/')
            })
          } else {
            alert('예기치 못한 오류가 발생하였습니다.')
            history.push('/')
          }
        }
        return
      }

      const jsonData = res['data']

      if (userInfo['role'] === 'admin') {
        setIsOwner(true)
      }
      if (jsonData?.type === 'company') {
        setIsCompany(true)
      }
      if (jsonData?.is_member === true) {
        setIsDotBtn(true)
      }
      setGroupInfo(jsonData)
    } catch (err) {
      console.log(err)
    }
  }
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (isCompany === true && [null, undefined].includes(userInfo['id'])) {
      setCenterModalVisible(true)
      setCenterModalDataList({ description: '해당 게시물을 열람할 권한이 없습니다.' })
      setOnModalComplete(() => () => {
        setInitCenterModal(true)
        history.push('/')
      })
    } else if (isCompany === true && ![null, undefined].includes(groupInfo?.no)) {
      server.getRequestData(
        `users/${userInfo['id']}/companies/campaigns?status=published&no=${groupInfo['no']}`,
        (res) => {
          if (res.success !== 1) {
            return
          }
          const jsonData = res.data

          if (jsonData?.campaigns?.length === 0) {
            setCenterModalVisible(true)
            setCenterModalDataList({ description: '해당 게시물을 열람할 권한이 없습니다.' })
            setOnModalComplete(() => () => {
              setInitCenterModal(true)
              history.push('/')
            })
          }
        },
      )
    }
  }, [isCompany, groupInfo])
  //handleModal
  const exitCampaignRequest = async () => {
    try {
      const resultData = await server.deleteRequestData(`campaigns/${match.params.id}/members`)
      if (resultData['success'] === 0) {
        return
      }
      history.replace('/')
      setVisible(false)
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.log(error)
      }
    }
  }
  const cancelWaiting = async () => {
    try {
      const response = await server.deleteRequestData(`campaigns/${match.params.id}/waitings`)
      if (response['success'] !== 1) {
        return
      }
      history.replace('/')
      setInitBottomModal(true)
    } catch (error) {
      console.log('error')
      console.log(error)
    }
  }

  const deleteCampaignRequest = async () => {
    try {
      const resultData = await server.deleteRequestData(`campaigns/${match.params.id}`, {
        no: match.params.id,
      })
      if (resultData['success'] === 0) {
        return
      }
      history.replace('/')
      setVisible(false)
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.log(error)
      }
    }
  }

  const handleCheckWaitingMember = (waitingList) => {
    if (waitingList?.status === 'pending' || waitingList?.status === 'denied') {
      setIsDotBtn(true)
      setIsWaitingMember(true)
      return
    }
    setIsWaitingMember(false)
  }

  const handleModalState = () => {
    if (groupInfo.role === 'admin' || userInfo.role === 'admin') {
      setDataList([
        { type: 'redirect', text: '수정', path: '', style: {} },
        {
          type: 'callback',
          text: '삭제',
          callback: deleteCampaignRequest,
          style: { color: '#DE0000' },
        },
      ])
    } else if (groupInfo?.is_member) {
      setDataList([
        {
          type: 'callback',
          text: '챌린지 참여취소',
          callback: () => {
            setCenterModalVisible(true)
            setVisible(false)
            setCenterModalDataList({
              title: '챌린지 탈퇴',
              description: '챌린지 탈퇴 시 인증사진, 보유 스티커,\n루틴 기록이 삭제됩니다',
            })
            setOnModalComplete(() => () => {
              setInitCenterModal(true)
              exitCampaignRequest()
              cancelWaiting()
            })
            setOnModalCancel(() => () => {
              setInitCenterModal(true)
            })
          },
          style: { color: '#DE0000' },
        },
      ])
    } else if (isWaitingMember) {
      setDataList([
        {
          type: 'callback',
          text: '챌린지 신청 취소',
          callback: () => {
            setCenterModalVisible(true)
            setVisible(false)
            setCenterModalDataList({
              title: '챌린지 신청 취소',
              description:
                '챌린지 신청 취소 시\n승인 검토 중인 사항이 초기화됩니다.\n신청을 취소하시겠어요?',
            })
            setOnModalComplete(() => () => {
              cancelWaiting()
              setInitCenterModal(true)
            })
            setOnModalCancel(() => () => {
              setInitCenterModal(true)
            })
          },
          style: { color: '#DE0000' },
        },
      ])
    }

    setVisible(true)
  }
  //페이지가 렌더링이 되었을 때 한번 호출
  useEffect(() => {
    loadCampaignInfo()
  }, [])
  const loadCampaignInfo = () => {
    server.getRequestData(`campaigns/${match.params.id}`, infoCallBack)
  }

  useEffect(() => {
    if (match?.isExact === true) {
      if (groupInfo?.start_date && groupInfo?.start_date > formatDate()) {
        history.replace(`${match.url}/info`)
      } else if (!groupInfo['is_member']) {
        history.replace(`${match.url}/info`)
      } else {
        history.replace(`${match.url}/achievement`)
      }
    }
  }, [])

  // const handleClickBack = () => {
  //   if(history.length > 1) {
  //     const prevPath = history.location;
  //     history.goBack();
  //     setTimeout(() => {
  //       const newPath = history.location;
  //       if(prevPath === newPath) {
  //         history.replace('/');
  //       }
  //     }, 100)
  //   } else if(history.length === 1 || history.location.pathname === `/campaign/${match.params.id}/info` || history.location.pathname === `/campaign/${match.params.id}`){
  //     history.replace('/');
  //   }
  // }

  return (
    <CampaignInner>
      <FixedTopNav>
        <TitleHeader
          title={groupInfo['title']}
          isShare={true}
          shareTitle={groupInfo['title']}
          shareDescription={groupInfo['description']}
          shareImg={
            groupInfo['cover_img']
              ? `${constants.imagePath}/campaign_cover_img/${groupInfo['cover_img']}`
              : null
          }
          handleModalState={handleModalState}
          isDotBtn={isDotBtn}
          // onBackBtn={handleClickBack}
          // onBackBtn={() => history.replace('/')}
        />
        <CampaignNavBar
          match={match}
          setCenterModalVisible={setCenterModalVisible}
          setCenterModalDataList={setCenterModalDataList}
          setOnModalComplete={setOnModalComplete}
          setInitCenterModal={setInitCenterModal}
          userInfo={userInfo}
          groupInfo={groupInfo}
        />
        <DummySpacer> </DummySpacer>
      </FixedTopNav>
      <BodyWrapper>
        {!isEmpty(groupInfo) ? (
          <>
            <Route
              exact
              path={[`/campaign/:id`, `/campaign/:id/info`]}
              render={(props) => (
                <CampaignMainLayout
                  {...props}
                  targetNo={`${match.params.id}`}
                  onCheckWaitingMember={handleCheckWaitingMember}
                  onReloadReq={() => {
                    loadCampaignInfo()
                  }}
                />
              )}
            />
            <Route
              exact
              path={`/campaign/:no/community`}
              render={({ match }) => (
                <Community no={match.params.no} isOwner={isOwner} type="campaign" />
              )}
            />
            <Route
              exact
              path={`/campaign/:id/feed`}
              render={({ match }) => <FeedGallery params={match['params']} type="campaign" />}
              setShowModal={setShowModal}
            />
            {/* <Route exact path={`/campaign/:id/achievement`} render={({match}) => <CampaignAchievementLayout campaignInfo={groupInfo} campaignNo={match['params']['id']} isMember={groupInfo['is_member']}/>} /> */}
            <Route
              exact
              path="/campaign/:id/feed/:post"
              render={({ match }) => <FeedLayout params={match['params']} type="campaign" />}
            />
            {/* <Route exact path={`/campaign/:id/post/:postNo`} render={({match}) => <CommunityCommentLayout match={match} postNo={match['params']['postNo']}/>}/> */}
            <Route exact path={`/campaign/:id/post/:no`} component={Community_comment} />
          </>
        ) : null}
        <BottomModal visible={visible} setVisible={setVisible} dataList={dataList} />
        <CenterModal
          modalVisible={centerModalVisible}
          setModalVisible={setCenterModalVisible}
          dataList={centerModalDataList}
          onCancel={onModalCancel}
          onComplete={onModalComplete}
        />
      </BodyWrapper>
    </CampaignInner>
  )
}

const CampaignInner = styled.div`
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-flow: column;
`
const FixedTopNav = styled.div`
  flex: 0 1 auto;
`
const DummySpacer = styled.div`
  height: calc(100vw * (84 / 375));
`
const BodyWrapper = styled.div`
  flex: 1 1 auto;
  overflow: hidden;
  height: 100%;
`
